/**
 * @format
 * @description Static Elections Results page
 */
export default {
  // available-slots-for-tier: {
  //   html: [],
  //   ldbd: [],
  //   flex: [],
  //   flex2: [],
  //   flex3: [],
  // },
  mobile: {
    html: [[1, 1]],
    flex: [[300, 250]],
    flex2: [
      [300, 250],
      [300, 600]
    ],
    flex3: [[300, 250]]
  },
  portrait: {
    html: [[1, 1]],
    ldbd: [[728, 90]],
    flex: [[728, 90]],
    flex2: [[728, 90]]
  },
  landscape: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1000, 250]
    ],
    flex: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 250],
      [1000, 250]
    ],
    flex2: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 250],
      [1000, 250]
    ]
  },
  desktop: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1000, 250]
    ],
    flex: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 250],
      [1000, 250]
    ],
    flex2: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 250],
      [1000, 250]
    ]
  }
};
